import React, { useMemo } from 'react';
import { CheckboxMultiField } from 'Shared/form/CheckboxMultiField';
import { useFormikContext } from 'formik';
import { sortBy } from 'lodash';
import { setWorkQueueFilterGenerator } from '../../workQueue.utils';
import useFetchPatientLabelsMenu from 'App/hooks/useFetchPatientLabelsMenu';

const PatientLabelsFilter = () => {
    const { data: availablePatientLabels } = useFetchPatientLabelsMenu();
    const {
        values: { filterParams },
        setFieldValue,
    } = useFormikContext();
    const { patientLabels } = filterParams;
    const setWorkQueueFilter = setWorkQueueFilterGenerator(setFieldValue);

    const options = useMemo(() => {
        return sortBy(
            availablePatientLabels?.map((opt) => ({ id: opt.valueName, option: opt.valueName })),
            'option'
        );
    }, [availablePatientLabels]);

    return (
        <div className="filter form-group">
            {options.length ? (
                <fieldset>
                    <legend className="control-label filter-header">Patient Labels</legend>
                    <CheckboxMultiField
                        fieldName="filterParams.patientLabels"
                        value={patientLabels}
                        options={options}
                        onChange={(value) => {
                            setWorkQueueFilter(filterParams, 'patientLabels', value, true);
                        }}
                    />
                </fieldset>
            ) : null}
        </div>
    );
};

export default PatientLabelsFilter;
